import { forwardRef, useMemo } from 'react'
import { twMerge } from 'tailwind-merge'

import { Block } from '../../models/Block'
import { Bookable, isFixedEventReservationItem } from '../../models/Bookable'
import { Booking } from '../../models/Booking'
import { Lesson } from '../../models/Lesson'
import { PSEvent } from '../../models/PSEvent'
import { ClickableTableRow, TableRow } from '../app/design/Table'

export const CalendarBookableTableRow = forwardRef<
    HTMLTableRowElement,
    React.HTMLAttributes<HTMLTableRowElement> & {
        bookable: Bookable
        isClickable?: boolean
    }
>(({ bookable, isClickable = true, children, ...props }, ref) => {
    const href = useMemo(() => {
        if (bookable instanceof Booking) return `/bookings/${bookable.id}`
        if (bookable instanceof Lesson) return `/lessons/${bookable.id}`
        if (bookable instanceof Block) return `/blocks/${bookable.id}/edit`
        if (bookable instanceof PSEvent && bookable.ownerIsMe) return `/events/${bookable.id}`
        if (isFixedEventReservationItem(bookable)) return `/reservations/${bookable.id}`
        return ''
    }, [bookable])

    return isClickable ? (
        <ClickableTableRow
            ref={ref}
            className={twMerge('cursor-pointer', props.className)}
            href={href}
            {...props}
        >
            {children}
        </ClickableTableRow>
    ) : (
        <TableRow ref={ref} {...props}>
            {children}
        </TableRow>
    )
})
